import { setComponentMapOverrides } from '@jutro/uiconfig';
import PostFNOLUploadComponent from './Summary/Component/PostFNOLUploadComponent/PostFNOLUploadComponent';
import STPUploadPhotosPage from './STPUploadPhotosPage/STPUploadPhotosPage';
import UploadComponentForSTP from './UploadComponentForSTP/UploadComponentForSTP';
import MFALoginComponent from './MFALogin/MFALoginComponent';
import SasriaFNOLWherePage from './Where/SasriaFNOLWherePage';
import SasriaPropertyIncident from './SasriaPropertyIncident/SasriaPropertyIncident';
import AddPaymentPopup from '../sasria-capability-fnol-common-react/AddPaymentPopup/AddPaymentPopup.jsx';

setComponentMapOverrides(
    {
        SasriaFNOLWherePage: { component: 'SasriaFNOLWherePage' },
        SasriaPropertyIncident: { component: 'SasriaPropertyIncident' },
        PostFNOLUploadComponent: { component: 'PostFNOLUploadComponent' },
        STPUploadPhotosPage: { component: 'STPUploadPhotosPage' },
        UploadComponentForSTP: { component: 'UploadComponentForSTP' },
        MFALoginComponent: { component: 'MFALoginComponent' },
        AddPaymentPopup
    },
    {
        SasriaFNOLWherePage,
        SasriaPropertyIncident,
        PostFNOLUploadComponent,
        STPUploadPhotosPage,
        UploadComponentForSTP,
        MFALoginComponent,
        AddPaymentPopup
    }
);

export {
    SasriaFNOLWherePage as default,
    SasriaPropertyIncident,
    PostFNOLUploadComponent,
    STPUploadPhotosPage,
    UploadComponentForSTP,
    MFALoginComponent,
    AddPaymentPopup
};

export { default as SasriaClaimLobOptionsMenu } from './SasriaCustomComponents/SasriaClaimLobOptionsMenu/SasriaClaimLobOptionsMenu';
